<template>
    <div :class="!simple ? 'recap-wrapper' : !icon ? 'recap-wrapper-mobile' : 'recap-wrapper-icon'">
        <v-row v-if="!simple">
            <v-col :cols="12" class=" mb-2">
                <!-- VARIANTA: alespoň jedno video existuje -->
                <v-btn v-if="hasAnyVideo" class="recap-btn border-table d-flex align-center justify-center"
                    variant="outlined" @click="onMainButtonClick">

                    <v-icon class="mr-2" size="20">mdi-play-circle</v-icon>
                    {{ $t('watchRecap') }}
                </v-btn>

                <!-- VARIANTA: žádné video a uživatel je admin -->
                <v-btn v-if="!hasAnyVideo && isLeagueAdmin" class="recap-btn border-table d-flex align-center justify-center"
                    variant="outlined" @click="onMainButtonClick">
                    <v-icon class="mr-2" size="20">mdi-plus-circle</v-icon>
                    {{ $t('eventRecap.addVideo') }}
                </v-btn>
            </v-col>
        </v-row>
        <div v-else style="justify-content:center !important">
            <span v-if="props.icon" @click="onMainButtonClick"> <v-icon :color="props.color">{{ props.icon }}</v-icon></span>
            <span v-else @click="onMainButtonClick" class="href-text">Highlights</span>
        </div>

        <!-- CONTEXT MENU: výběr typu videa -->
        <Teleport to="body">
          <transition name="fade">
            <div v-if="ctxMenuOpen" class="ctx-overlay" @click="closeCtxMenu" />
          </transition>
          <transition name="context-menu">
            <div v-if="ctxMenuOpen" class="context-menu-content-slot" :style="ctxMenuPosition" @click.stop>
              <!-- Sport.Video -->
              <div class="context-menu-item" @click="onCtxSportVideo">
                <span>Sport.Video</span>
                <v-icon size="18">{{ hasSportVideo ? 'mdi-play-circle-outline' : 'mdi-plus-circle-outline' }}</v-icon>
              </div>
              <div class="context-menu-divider" />
              <!-- YouTube -->
              <div class="context-menu-item" @click="onCtxYoutube">
                <span>YouTube</span>
                <v-icon size="18">{{ hasYoutube ? 'mdi-play-circle-outline' : 'mdi-plus-circle-outline' }}</v-icon>
              </div>
              <!-- Delete options for admin -->
              <template v-if="isLeagueAdmin && (hasSportVideo || hasYoutube)">
                <div class="context-menu-divider" />
                <div v-if="hasSportVideo" class="context-menu-item context-menu-item--danger" @click="confirmDeleteType = 'sport'; confirmDelete = true; closeCtxMenu()">
                  <span>{{ $t('eventRecap.deleteSportVideo') }}</span>
                  <v-icon size="18">mdi-trash-can-outline</v-icon>
                </div>
                <div v-if="hasYoutube" class="context-menu-item context-menu-item--danger" @click="confirmDeleteType = 'youtube'; confirmDelete = true; closeCtxMenu()">
                  <span>{{ $t('eventRecap.deleteYoutube') }}</span>
                  <v-icon size="18">mdi-trash-can-outline</v-icon>
                </div>
              </template>
            </div>
          </transition>
        </Teleport>

        <!-- MODAL: Přehrávač Sport.Video -->
        <v-dialog v-model="playerOpen" max-width="900" height="75vw" scrim="black" :style="{ '--v-overlay-opacity': 0.85 }" :z-index="10000">
            <v-card class="video-card">
                <v-card-title class="d-flex align-center py-0">
                    <div class="d-flex align-center">
                        <v-img v-if="props.event.leagueImage" :src="`${UPLOADS}/leagues/h200-${props.event.leagueImage}`"
                            alt="League" width="50" height="50" cover class="mr-3" />
                        <span class="text-subtitle-1 font-weight-medium font-white">
                            {{ props.event.title || 'Video' }}
                        </span>
                    </div>

                    <v-spacer />

                    <v-btn icon variant="text" @click="playerOpen = false" size="small" :title="$t('close') || 'Close'">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <div>
                        <VideoPlayer :embed-url="props.event.eventVideo"/>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- MODAL: Přehrávač YouTube -->
        <v-dialog v-model="youtubePlayerOpen" max-width="900" height="75vw" scrim="black" :style="{ '--v-overlay-opacity': 0.85 }" :z-index="10000">
            <v-card class="video-card">
                <v-card-title class="d-flex align-center py-0">
                    <div class="d-flex align-center">
                        <v-img v-if="props.event.leagueImage" :src="`${UPLOADS}/leagues/h200-${props.event.leagueImage}`"
                            alt="League" width="50" height="50" cover class="mr-3" />
                        <span class="text-subtitle-1 font-weight-medium font-white">
                            {{ props.event.title || 'Video' }}
                        </span>
                    </div>

                    <v-spacer />

                    <v-btn icon variant="text" @click="youtubePlayerOpen = false" size="small" :title="$t('close') || 'Close'">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <div class="youtube-shell">
                      <iframe
                        :src="youtubeEmbedUrl"
                        style="width: 100%; aspect-ratio: 16/9; border: 0;"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                        allowfullscreen
                      />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>


        <!-- MODAL: Přidat Sport.Video (URL) -->
        <BottomSheetModal v-model="addOpen" auto-height :confirm-disabled="saving || !formUrl" @confirm="saveVideo">
          <template #title>{{ $t('eventRecap.addSportVideo') }}</template>

          <IosSection form :title="$t('eventRecap.videoLinkTitle')">
            <IosInput
              v-model="formUrl"
              :placeholder="$t('eventRecap.videoLinkPlaceholder')"
              first
              last
            />
          </IosSection>

          <div v-if="formError" class="form-error">
            <v-icon size="16" color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
            {{ formError }}
          </div>
        </BottomSheetModal>

        <!-- MODAL: Přidat YouTube (URL) -->
        <BottomSheetModal v-model="addYoutubeOpen" auto-height :confirm-disabled="saving || !formYoutubeUrl" @confirm="saveYoutube">
          <template #title>{{ $t('eventRecap.addYoutube') }}</template>

          <IosSection form :title="$t('eventRecap.youtubeLinkTitle')">
            <IosInput
              v-model="formYoutubeUrl"
              :placeholder="$t('eventRecap.youtubeLinkPlaceholder')"
              first
              last
            />
          </IosSection>

          <div v-if="formYoutubeError" class="form-error">
            <v-icon size="16" color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
            {{ formYoutubeError }}
          </div>
        </BottomSheetModal>

        <!-- Potvrzení smazání -->
        <CenteredModal v-model="confirmDelete" :show-close-button="true" max-width="350px" :z-index="10001">
          <div class="delete-confirm-dialog">
            <div class="delete-confirm-icon">
              <v-icon size="48" color="error">mdi-delete-alert</v-icon>
            </div>
            <h3 class="delete-confirm-title">{{ $t('eventRecap.deleteVideo') }}</h3>
            <p class="delete-confirm-subtitle">
              {{ confirmDeleteType === 'youtube' ? $t('eventRecap.deleteYoutubeConfirm') : $t('eventRecap.deleteVideoConfirm') }}
            </p>
            <div class="delete-confirm-actions">
              <button class="delete-confirm-btn delete-confirm-btn--cancel" @click="confirmDelete = false">
                {{ $t('cancel') }}
              </button>
              <button
                class="delete-confirm-btn delete-confirm-btn--confirm"
                :disabled="deleting"
                @click="deleteVideo"
              >
                {{ $t('eventRecap.delete') }}
              </button>
            </div>
          </div>
        </CenteredModal>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import VideoPlayer from '@/components/VideoPlayer.vue';
import { Capacitor } from '@capacitor/core'
import { ScreenOrientation } from '@capacitor/screen-orientation'
import { isTabletDevice } from '@/utils/deviceUtils'

const { t } = useI18n({ useScope: 'global' });
import BottomSheetModal from '@/components/BottomSheetModal.vue'
import CenteredModal from '@/components/CenteredModal.vue'
import IosSection from '@/components/ios/IosSection.vue'
import IosInput from '@/components/ios/IosInput.vue'
import axiosInstance from '@/services/axiosInstance'

const UPLOADS = import.meta.env.VITE_UPLOADS;

type EventLike = { _id?: string; eventVideo?: string | null; eventYoutube?: string | null; leagueImage?: string | null, title?: string | null }

const props = defineProps<{
    event: EventLike
    isLeagueAdmin: boolean
    simple?: boolean,
    icon?: string,
    color?: string
}>()

const emit = defineEmits<{
    (e: 'updated'): void
}>()

/** Stav / zobrazení */
const playerOpen = ref(false)
const youtubePlayerOpen = ref(false)
const addOpen = ref(false)
const addYoutubeOpen = ref(false)
const confirmDelete = ref(false)
const confirmDeleteType = ref<'sport' | 'youtube'>('sport')
const saving = ref(false)
const deleting = ref(false)
const formError = ref<string | null>(null)
const formYoutubeError = ref<string | null>(null)

/** Context menu */
const ctxMenuOpen = ref(false)
const ctxMenuPosition = ref<Record<string, string>>({})

/** Data */
const hasSportVideo = computed(() => !!props.event?.eventVideo)
const hasYoutube = computed(() => !!props.event?.eventYoutube)
const hasAnyVideo = computed(() => hasSportVideo.value || hasYoutube.value)
const embedSrc = computed(() => props.event?.eventVideo || '')
const iframeRef = ref<HTMLIFrameElement | null>(null)
const iframeHeight = ref(620)
const SPORT_VIDEO_ORIGIN = 'https://sport.video'

/** YouTube embed URL */
const youtubeEmbedUrl = computed(() => {
  const raw = props.event?.eventYoutube
  if (!raw) return ''
  try { return toYoutubeEmbedUrl(raw) } catch { return '' }
})

// ID iframe (jen kosmetika)
const iframeId = computed(() => 'sv-embed-' + (props.event?._id || 'event'))

async function unlockOrientationForVideo() {
  if (!Capacitor.isNativePlatform() || isTabletDevice()) return
  await ScreenOrientation.unlock().catch(() => {})
}

async function lockPortraitOrientation() {
  if (!Capacitor.isNativePlatform() || isTabletDevice()) return
  await ScreenOrientation.lock({ orientation: 'portrait' }).catch(() => {})
}

/** Form */
const formRef = ref()
const formUrl = ref<string>('')
const formYoutubeUrl = ref<string>('')



function toEmbedUrl(input: string): string {
  if (!input) throw new Error('Prázdný odkaz.');
  let trimmed = input.trim();

  // Pokud vstup obsahuje <iframe>, extrahuj src atribut
  const iframeMatch = trimmed.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  if (iframeMatch) {
    trimmed = iframeMatch[1];
  }

  // doplnit schema, pokud chybí
  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    url = new URL('https://' + trimmed);
  }

  // povolit jen sport.video
  const host = url.hostname.toLowerCase();
  if (!(host === 'sport.video' || host.endsWith('.sport.video'))) {
    throw new Error('URL musí být z domény sport.video.');
  }

  // normalizace cesty -> segmenty
  const parts = url.pathname.replace(/\/+/g, '/').replace(/^\/|\/$/g, '').split('/');

  // 1) už je to embed
  if (parts[0] === 'embed-game') {
    if (!parts[1]) throw new Error('Chybí identifikátor zápasu.');
    return `https://sport.video/embed-game/${parts[1]}`;
  }

  // 2) najít segment končící na `-<číslo>`
  const idxFromEnd = [...parts].reverse().findIndex(seg => /-\d{5,}$/.test(seg));
  if (idxFromEnd !== -1) {
    const idx = parts.length - 1 - idxFromEnd;
    return `https://sport.video/embed-game/${parts[idx]}`;
  }

  // 3) fallback: pokud poslední je UUID, vezmi předposlední; jinak poslední
  const last = parts[parts.length - 1] || '';
  const uuidLike = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(last);
  const candidate = uuidLike ? parts[parts.length - 2] : last;
  if (!candidate) throw new Error('Nepodařilo se rozpoznat identifikátor zápasu.');
  return `https://sport.video/embed-game/${candidate}`;
}



// Povolíme libovolné URL z domény sport.video (embed i "ne-embed")
const isValidSportVideoUrl = (v: string) => {
  try { return !!toEmbedUrl(v); } catch { return false; }
};
const urlRule = (v: string) => isValidSportVideoUrl(v) || 'Vlož platný Sport.Video odkaz';


/** YouTube URL → embed URL */
function toYoutubeEmbedUrl(input: string): string {
  if (!input) throw new Error('Prázdný odkaz.');
  const trimmed = input.trim();

  let url: URL;
  try { url = new URL(trimmed); } catch { url = new URL('https://' + trimmed); }

  const host = url.hostname.toLowerCase().replace(/^www\./, '');

  let videoId = '';

  if (host === 'youtu.be') {
    videoId = url.pathname.replace(/^\//, '').split('/')[0];
  } else if (host === 'youtube.com' || host === 'm.youtube.com') {
    if (url.pathname.startsWith('/embed/')) {
      videoId = url.pathname.split('/')[2];
    } else if (url.pathname.startsWith('/shorts/')) {
      videoId = url.pathname.split('/')[2];
    } else {
      videoId = url.searchParams.get('v') || '';
    }
  }

  if (!videoId) throw new Error('Nepodařilo se rozpoznat YouTube video ID.');
  return `https://www.youtube.com/embed/${videoId}`;
}


/** Context menu */
function openCtxMenu(event?: MouseEvent) {
  // Pokud existuje jen jeden typ a admin nemůže přidávat, otevři přímo
  if (!props.isLeagueAdmin) {
    if (hasSportVideo.value && !hasYoutube.value) { playerOpen.value = true; return; }
    if (hasYoutube.value && !hasSportVideo.value) { youtubePlayerOpen.value = true; return; }
    if (!hasAnyVideo.value) return;
  }

  // Admin bez žádného videa = rovnou přeskočit menu pokud má jen jednu možnost? Ne, vždy ukázat menu.

  const el = event?.target as HTMLElement | undefined;
  const rect = el?.closest('button, .action-button, span, .recap-btn')?.getBoundingClientRect()
    ?? el?.getBoundingClientRect();

  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const MENU_W = 260;
  const GAP = 8;

  const posStyle: Record<string, string> = {
    position: 'fixed',
    width: `${MENU_W}px`,
    zIndex: '10000',
  };

  if (rect) {
    const triggerCX = rect.left + rect.width / 2;

    if (triggerCX > vw / 2) {
      const right = vw - rect.right;
      posStyle.right = `${Math.max(12, right)}px`;
      posStyle.left = 'auto';
    } else {
      let left = rect.left;
      if (left + MENU_W > vw - 12) left = vw - MENU_W - 12;
      if (left < 12) left = 12;
      posStyle.left = `${left}px`;
      posStyle.right = 'auto';
    }

    posStyle.top = `${rect.bottom + GAP}px`;
    posStyle.bottom = 'auto';
  } else {
    // Fallback: vycentrovat horizontálně, umístit do horní třetiny
    posStyle.left = `${Math.max(12, (vw - MENU_W) / 2)}px`;
    posStyle.right = 'auto';
    posStyle.top = `${Math.round(vh * 0.3)}px`;
    posStyle.bottom = 'auto';
  }

  ctxMenuPosition.value = posStyle;
  document.documentElement.style.overflow = 'hidden';
  ctxMenuOpen.value = true;
}

function closeCtxMenu() {
  ctxMenuOpen.value = false;
  document.documentElement.style.overflow = '';
}

function onCtxSportVideo() {
  closeCtxMenu();
  if (hasSportVideo.value) {
    playerOpen.value = true;
  } else if (props.isLeagueAdmin) {
    openAddSportVideo();
  }
}

function onCtxYoutube() {
  closeCtxMenu();
  if (hasYoutube.value) {
    youtubePlayerOpen.value = true;
  } else if (props.isLeagueAdmin) {
    openAddYoutube();
  }
}

/** Hlavní tlačítko - otevře context menu nebo rovnou přehrávač */
function onMainButtonClick(event?: MouseEvent) {
  // Pokud je jen jedno video a uživatel není admin, otevři rovnou
  const onlyOneSportVideo = hasSportVideo.value && !hasYoutube.value && !props.isLeagueAdmin;
  const onlyOneYoutube = hasYoutube.value && !hasSportVideo.value && !props.isLeagueAdmin;

  if (onlyOneSportVideo) { playerOpen.value = true; return; }
  if (onlyOneYoutube) { youtubePlayerOpen.value = true; return; }

  openCtxMenu(event);
}

/** Akce */
function openPlayer() {
    playerOpen.value = true
}

function openYoutubePlayer() {
    youtubePlayerOpen.value = true
}

function openAddSportVideo() {
    formUrl.value = ''
    formError.value = null
    addOpen.value = true
}

function openAddYoutube() {
    formYoutubeUrl.value = ''
    formYoutubeError.value = null
    addYoutubeOpen.value = true
}

function openAdd() {
    openAddSportVideo()
}

async function saveVideo() {
  formError.value = null;
  try {
    const embedUrl = toEmbedUrl(formUrl.value);
    if (!props.event?._id) throw new Error('Chybí ID zápasu.');
    saving.value = true;
    await axiosInstance.post(`/events/${props.event._id}/video`, { embedUrl });
    addOpen.value = false;
    emit('updated');
  } catch (e: any) {
    formError.value = e?.message || 'Uložení se nezdařilo.';
  } finally {
    saving.value = false;
  }
}

async function saveYoutube() {
  formYoutubeError.value = null;
  try {
    const embedUrl = toYoutubeEmbedUrl(formYoutubeUrl.value);
    if (!props.event?._id) throw new Error('Chybí ID zápasu.');
    saving.value = true;
    await axiosInstance.post(`/events/${props.event._id}/youtube`, { embedUrl });
    addYoutubeOpen.value = false;
    emit('updated');
  } catch (e: any) {
    formYoutubeError.value = e?.message || 'Uložení se nezdařilo.';
  } finally {
    saving.value = false;
  }
}


async function deleteVideo() {
  if (!props.event?._id) return
  deleting.value = true
  try {
    if (confirmDeleteType.value === 'youtube') {
      await axiosInstance.delete(`/events/${props.event._id}/youtube`)
    } else {
      await axiosInstance.delete(`/events/${props.event._id}/video`)
    }
    confirmDelete.value = false
    playerOpen.value = false
    youtubePlayerOpen.value = false
    emit('updated')
  } catch (e) {
    // případně toast/chyba
  } finally {
    deleting.value = false
  }
}

/** PostMessage pro dynamickou výšku iframe (ofiko chování Sport.Video) */
function onMessage(ev: MessageEvent) {
    if (ev.origin !== SPORT_VIDEO_ORIGIN) return
    if (typeof ev.data === 'number' && ev.data > 0) {
        iframeHeight.value = ev.data
    }
}

function pingIframe() {
    try {
        iframeRef.value?.contentWindow?.postMessage('message', SPORT_VIDEO_ORIGIN)
    } catch { }
}

watch([playerOpen, youtubePlayerOpen], ([sportOpen, ytOpen]) => {
  if (sportOpen || ytOpen) {
    void unlockOrientationForVideo()
    return
  }
  void lockPortraitOrientation()
})

onMounted(() => window.addEventListener('message', onMessage, false))
onBeforeUnmount(() => {
  void lockPortraitOrientation()
  window.removeEventListener('message', onMessage, false)
})

// Expose openPlayer and openAdd for external triggering
defineExpose({ openPlayer, openAdd, openCtxMenu, openYoutubePlayer, openAddYoutube })
</script>

<style scoped>
.recap-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.recap-wrapper-mobile {
    display: inline-flex;
    align-items: center;
    justify-content: left;
    width: 100%;
}

/* Styl tlačítka podobný „Recap“ pilulce ze screenu */
.recap-btn {
    padding: 20px;
    background: rgba(var(--v-theme-sheetSection), 1) !important;
    color: rgb(var(--v-theme-brand)) !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 600 !important;
    width: 100%;
}

.recap-btn .v-icon {
    color: rgb(var(--v-theme-brand)) !important;
}

.recap-delete {
    color: rgb(var(--v-theme-error)) !important;
}

.recap-delete .v-icon {
    color: rgb(var(--v-theme-error)) !important;
}

.iframe-shell {
    position: relative;
    width: 100%;
    background: #000;
    border-radius: 10px;
    overflow: hidden;
}

.youtube-shell {
    position: relative;
    width: 100%;
    background: #000;
    overflow: hidden;
}

.hint {
    font-size: 12px;
    color: rgba(var(--v-theme-sheetText), 0.5);
    margin-top: 6px;
}

.video-card {
    background: rgba(var(--v-theme-sheetSection), 1) !important;
    color: rgba(var(--v-theme-sheetText), 1) !important;
    border-radius: 10px !important;
}

.font-white {
    color: rgba(var(--v-theme-sheetText), 1) !important;
}

.form-error {
    display: flex;
    align-items: center;
    padding: 0 16px;
    margin-top: -16px;
    font-size: 0.82rem;
    color: rgb(var(--v-theme-error));
}

/* Delete confirm dialog */
.delete-confirm-dialog {
  padding: 24px;
  text-align: center;
}

.delete-confirm-icon {
  margin-bottom: 16px;
}

.delete-confirm-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.delete-confirm-subtitle {
  font-size: 0.9rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  margin-bottom: 24px;
}

.delete-confirm-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.delete-confirm-btn {
  padding: 10px 24px;
  border-radius: 12px;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.delete-confirm-btn--cancel {
  background: rgba(var(--v-theme-on-surface), 0.1);
  color: inherit;
}

.delete-confirm-btn--confirm {
  background: rgb(var(--v-theme-error));
  color: white;
}

.delete-confirm-btn--confirm:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.delete-confirm-btn:active:not(:disabled) {
  transform: scale(0.96);
}
</style>

<style>
/* Teleported overlay – must be unscoped to apply on <body> */
.ctx-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 9999;
}
</style>
